<div class="modal-alerta">
  <obc-botao-fechar class="modal-alerta__botao-fechar" (btnFechar)="fecharModal()"></obc-botao-fechar>
  <div class="modal-alerta__info">
    <span class="modal-alerta__icone-atencao"></span>
    <h2 class="modal-alerta__subtitulo">{{ data.titulo }}</h2>
    <p class="modal-alerta__mensagem">{{ data.mensagem }}</p>
  </div>
</div>
